import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
console.log('API Base URL:', rawBaseUrl);
const API_BASE_URL = rawBaseUrl.replace(/\/+$/, '');

function isAbsoluteUrl(url) {
	return /^https?:\/\//i.test(url);
}

function toApiUrl(url) {
	if (!url || !API_BASE_URL || isAbsoluteUrl(url)) {
		return url;
	}
	const normalizedPath = url.startsWith('/') ? url : `/${url}`;
	return `${API_BASE_URL}${normalizedPath}`;
}

axios.interceptors.request.use((config) => {
	if (config?.url) {
		config.url = toApiUrl(config.url);
	}
	return config;
});

const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init) => {
	if (typeof input === 'string') {
		return nativeFetch(toApiUrl(input), init);
	}

	if (input instanceof Request && !isAbsoluteUrl(input.url)) {
		const nextUrl = toApiUrl(input.url);
		const nextRequest = new Request(nextUrl, input);
		return nativeFetch(nextRequest, init);
	}

	return nativeFetch(input, init);
};

export { API_BASE_URL, toApiUrl };
